export default ({ axios }) => ({
    update: (id, body) => axios.patch(`/properties/${id}`, body),
    delete: (id) => axios.delete(`/properties/${id}`)
})



// WEBPACK FOOTER //
// ./src/api/properties.js